import React, { useEffect, useState } from 'react';
import { Github, Linkedin, Mail, ArrowUpRight, ArrowDown } from 'lucide-react';

const languages = [
  { name: 'Go', color: 'text-cyan-300', path: 'M1.811 10.231c-.047 0-.058-.023-.035-.059l.246-.315c.023-.035.081-.058.128-.058h4.172c.046 0 .058.035.035.07l-.199.303c-.023.036-.082.07-.117.07zM.047 11.306c-.047 0-.059-.023-.035-.058l.245-.316c.023-.035.082-.058.129-.058h5.328c.047 0 .07.035.058.07l-.093.28c-.012.047-.058.07-.105.07zm2.828 1.075c-.047 0-.059-.035-.035-.07l.163-.292c.023-.035.07-.07.117-.07h2.337c.047 0 .07.035.07.082l-.023.28c0 .047-.047.082-.082.082zm12.129-2.36c-.736.187-1.239.327-1.963.514-.176.046-.187.058-.339-.117-.176-.199-.316-.328-.573-.444-.737-.362-1.45-.257-2.115.175-.785.514-1.183 1.273-1.171 2.22.012.94.68 1.707 1.614 1.822.82.105 1.51-.176 2.044-.876.106-.14.2-.292.329-.491H11.32c-.246 0-.304-.152-.222-.35.152-.362.432-.97.596-1.273a.315.315 0 01.292-.175h4.253c-.023.316-.023.631-.07.947a4.983 4.983 0 01-.958 2.29c-.841 1.11-1.94 1.8-3.33 1.986-1.145.152-2.209-.07-3.143-.77-.865-.655-1.356-1.52-1.484-2.595-.152-1.274.222-2.419.993-3.424.83-1.086 1.928-1.776 3.272-2.02 1.098-.2 2.15-.07 3.096.571.62.421 1.063.97 1.356 1.648.07.105.023.164-.117.2z' },
  { name: 'TypeScript', color: 'text-blue-400', path: 'M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z' },
  { name: 'C#', color: 'text-purple-400', path: 'M12 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0zM9.426 7.12a5.55 5.55 0 011.985.38c.553.247 1.029.61 1.455 1.04.178.178.114.3-.078.418-.096.063-.192.13-.288.2-.16.11-.328.227-.488.32-.095.058-.166.04-.256-.04a2.948 2.948 0 00-1.008-.7 2.986 2.986 0 00-1.953-.1c-.47.127-.86.41-1.14.79a2.01 2.01 0 00-.36 1.27c.026.393.15.76.368 1.076.262.378.62.67 1.04.85.478.202.99.288 1.498.252a3.58 3.58 0 001.242-.323c.018-.008.036-.02.082-.044v-1.051H9.094c-.163 0-.196-.063-.196-.2v-.876c0-.136.04-.196.2-.196h2.943c.15 0 .2.04.2.193v2.494c0 .112-.014.216-.037.32a3.432 3.432 0 01-.626.555 5.332 5.332 0 01-1.762.798 5.16 5.16 0 01-1.79.133 4.634 4.634 0 01-2.055-.682 4.035 4.035 0 01-1.637-1.878 4.164 4.164 0 01-.244-2.243 4.3 4.3 0 01.886-2.022c.496-.638 1.127-1.13 1.885-1.395a5.163 5.163 0 011.565-.34zm5.657.183h1.1c.136 0 .2.04.23.164l1.52 5.655 1.533-5.66c.027-.1.078-.163.22-.163h1.065c.148 0 .19.064.156.2l-2.18 7.636c-.03.104-.08.16-.218.16h-.973c-.135 0-.193-.06-.226-.166l-1.58-5.584-1.562 5.582c-.033.108-.093.168-.228.168h-.972c-.132 0-.187-.06-.217-.158L9.836 7.505c-.038-.14 0-.202.15-.202h1.127c.135 0 .197.056.227.157l1.514 5.717z' },
  { name: 'SQL', color: 'text-orange-400', path: 'M4.834 5.092c-.93 0-1.678.744-1.678 1.66 0 .917.747 1.66 1.678 1.66.931 0 1.679-.743 1.679-1.66 0-.916-.748-1.66-1.68-1.66zm14.332 0c-.93 0-1.679.744-1.679 1.66 0 .917.748 1.66 1.68 1.66.93 0 1.678-.743 1.678-1.66 0-.916-.747-1.66-1.679-1.66zM12 8.835c-1.14 0-2.063.915-2.063 2.044 0 1.13.923 2.045 2.063 2.045s2.063-.916 2.063-2.045c0-1.13-.923-2.044-2.063-2.044zM4.834 12.67c-.93 0-1.678.743-1.678 1.66 0 .916.747 1.66 1.678 1.66.931 0 1.679-.744 1.679-1.66 0-.917-.748-1.66-1.68-1.66zm14.332 0c-.93 0-1.679.743-1.679 1.66 0 .916.748 1.66 1.68 1.66.93 0 1.678-.744 1.678-1.66 0-.917-.747-1.66-1.679-1.66z' },
  { name: 'Python', color: 'text-yellow-400', path: 'M14.25.18l.9.2.73.26.59.3.45.32.34.34.25.34.16.33.1.3.04.26.02.2-.01.13V8.5l-.05.63-.13.55-.21.46-.26.38-.3.31-.33.25-.35.19-.35.14-.33.1-.3.07-.26.04-.21.02H8.77l-.69.05-.59.14-.5.22-.41.27-.33.32-.27.35-.2.36-.15.37-.1.35-.07.32-.04.27-.02.21v3.06H3.17l-.21-.03-.28-.07-.32-.12-.35-.18-.36-.26-.36-.36-.35-.46-.32-.59-.28-.73-.21-.88-.14-1.05-.05-1.23.06-1.22.16-1.04.24-.87.32-.71.36-.57.4-.44.42-.33.42-.24.4-.16.36-.1.32-.05.24-.01h5.16l.69-.05.59-.14.5-.21.41-.28.33-.32.27-.35.2-.36.15-.36.1-.35.07-.32.04-.28.02-.21V6.07h2.09l.14.01zm-6.3 1.98l-.23.33-.08.41.08.41.23.34.33.22.41.09.41-.09.33-.22.23-.34.08-.41-.08-.41-.23-.33-.33-.22-.41-.09-.41.09zm13.09 3.95l.28.06.32.12.35.18.36.27.36.35.35.47.32.59.28.73.21.88.14 1.04.05 1.23-.06 1.23-.16 1.04-.24.86-.32.71-.36.57-.4.45-.42.33-.42.24-.4.16-.36.09-.32.05-.24.02-.16-.01h-8.22v.82h5.84l.01 2.76.02.36-.05.34-.11.31-.17.28-.25.26-.31.23-.38.2-.44.18-.51.15-.58.12-.64.1-.71.06-.77.04-.84.02-1.27-.05-1.07-.14-.9-.2-.73-.25-.59-.3-.45-.33-.34-.34-.25-.34-.16-.33-.1-.3-.04-.25-.02-.2.01-.13v-5.34l.05-.64.13-.54.21-.46.26-.38.3-.32.33-.24.35-.2.35-.14.33-.1.3-.06.26-.04.21-.02.13-.01h5.84l.69-.05.59-.14.5-.21.41-.28.33-.32.27-.35.2-.36.15-.36.1-.35.07-.32.04-.28.02-.21V6.07h2.09l.14.01zm-6.47 14.25l-.23.33-.08.41.08.41.23.33.33.23.41.08.41-.08.33-.23.23-.33.08-.41-.08-.41-.23-.33-.33-.23-.41-.08-.41.08z' },
];

const projects = [
  {
    id: 1,
    title: 'Spin',
    description: 'Local-first development environment manager for containerized services.',
    tech: ['Go', 'Docker', 'CLI'],
    image: '/images/spin.png',
    link: 'https://github.com/parkerstafford/spin',
  },
  {
    id: 2,
    title: 'Lingofi',
    description: 'A modern web application built with Next.js and TypeScript.',
    tech: ['Next.js', 'Tailwind', 'TypeScript', 'Postgres'],
    image: '/images/lingofi.png',
    link: 'https://lingofi.io',
  },
  {
    id: 3,
    title: 'Readex',
    description: 'Web application with Rust backend and React frontend.',
    tech: ['React', 'TypeScript', 'Rust', 'Postgres'],
    image: '/images/readex.png',
    link: 'https://readex.io',
  },
  {
    id: 4,
    title: 'DepGraph',
    description: 'Monorepo dependency analyzer with interactive graph visualization.',
    tech: ['Go', 'React', 'TypeScript', 'D3.js'],
    image: '/images/depgraph.png',
    link: 'https://github.com/parkerstafford/depgraph',
  },
  {
    id: 5,
    title: 'QuoteGen',
    description: 'iOS application for generating contractor invoices with AI assistance.',
    tech: ['Swift', 'SwiftUI', 'Supabase/Postgres'],
    image: '/images/quotegen.png',
    link: '#',
  },
];

function SectionLabel({ index, children }) {
  return (
    <div className="flex items-center gap-4 mb-12">
      <span className="font-mono text-xs text-zinc-500 tracking-widest">{index}</span>
      <span className="h-px w-8 bg-zinc-700" />
      <h2 className="text-3xl md:text-4xl font-semibold tracking-tight">{children}</h2>
    </div>
  );
}

export default function Portfolio() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="relative min-h-screen bg-zinc-950 text-white antialiased selection:bg-white selection:text-black">
      {/* Background: soft glow + fine grid */}
      <div className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute -top-40 left-1/2 h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-white/[0.06] blur-[140px]" />
        <div
          className="absolute inset-0 opacity-[0.35] [mask-image:radial-gradient(ellipse_at_top,black_20%,transparent_70%)]"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.05) 1px, transparent 1px)',
            backgroundSize: '56px 56px',
          }}
        />
      </div>

      {/* Navigation */}
      <nav
        className={`fixed top-0 z-50 w-full transition-all duration-300 ${
          scrolled ? 'bg-zinc-950/70 backdrop-blur-xl border-b border-white/[0.06]' : 'bg-transparent border-b border-transparent'
        }`}
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-5">
          <a href="#top" className="font-mono text-sm tracking-tight text-zinc-300 hover:text-white transition-colors">
            {'<dev/>'}
          </a>
          <div className="flex items-center gap-1">
            <a href="#projects" className="rounded-full px-4 py-2 text-sm text-zinc-400 hover:text-white hover:bg-white/[0.05] transition-colors">
              Projects
            </a>
            <a href="#contact" className="rounded-full px-4 py-2 text-sm text-zinc-400 hover:text-white hover:bg-white/[0.05] transition-colors">
              Contact
            </a>
            <a
              href="https://github.com/parkerstafford"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              className="ml-2 rounded-full p-2 text-zinc-400 hover:text-white hover:bg-white/[0.05] transition-colors"
            >
              <Github className="h-5 w-5" />
            </a>
          </div>
        </div>
      </nav>

      <main id="top" className="relative z-10">
        {/* Hero */}
        <header className="px-6 pt-40 pb-28 md:pt-48 md:pb-36">
          <div className="mx-auto max-w-6xl">
            <div className="max-w-3xl">
              <h1 className="mb-6 text-5xl font-semibold leading-[1.05] tracking-[-0.03em] md:text-7xl">
                Parker Stafford
              </h1>
              <p className="mb-10 max-w-2xl text-lg leading-relaxed text-zinc-400 md:text-xl">
                Software engineer building{' '}
                <span className="text-zinc-200">scalable enterprise applications</span>, from Go backends
                and TypeScript frontends to native iOS.
              </p>

              <div className="mb-12 flex flex-wrap gap-2.5">
                {languages.map((lang) => (
                  <div
                    key={lang.name}
                    className="group flex items-center gap-2 rounded-lg border border-white/[0.08] bg-white/[0.03] px-3 py-2 transition-colors hover:border-white/[0.16] hover:bg-white/[0.06]"
                  >
                    <svg className={`h-4.5 w-4.5 ${lang.color}`} width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d={lang.path} />
                    </svg>
                    <span className="text-sm text-zinc-300">{lang.name}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap items-center gap-3">
                <a
                  href="mailto:parkerdevwork@gmail.com"
                  className="group inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-medium text-black transition-all hover:bg-zinc-200 hover:shadow-[0_0_40px_-8px_rgba(255,255,255,0.5)]"
                >
                  Get in touch
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </a>
                <a
                  href="https://www.linkedin.com/in/parker-stafford-8a2320318/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full border border-white/[0.12] px-6 py-3 text-sm text-zinc-200 transition-colors hover:border-white/[0.3] hover:bg-white/[0.04]"
                >
                  <Linkedin className="h-4 w-4" />
                  LinkedIn
                </a>
              </div>
            </div>

            <a
              href="#projects"
              className="mt-24 hidden items-center gap-2 font-mono text-xs uppercase tracking-widest text-zinc-600 transition-colors hover:text-zinc-300 md:inline-flex"
            >
              <ArrowDown className="h-3.5 w-3.5 animate-bounce" />
              Selected work
            </a>
          </div>
        </header>

        {/* Projects */}
        <section id="projects" className="scroll-mt-24 px-6 py-24">
          <div className="mx-auto max-w-6xl">
            <SectionLabel index="01">Projects</SectionLabel>

            <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
              {projects.map((project) => {
                const external = project.link !== '#';
                return (
                  <a
                    key={project.id}
                    href={project.link}
                    target={external ? '_blank' : undefined}
                    rel={external ? 'noopener noreferrer' : undefined}
                    className="group relative flex flex-col overflow-hidden rounded-2xl border border-white/[0.08] bg-zinc-900/40 transition-all duration-300 hover:-translate-y-1 hover:border-white/[0.18] hover:shadow-[0_24px_60px_-24px_rgba(0,0,0,0.8)]"
                  >
                    <div className="relative aspect-[16/10] overflow-hidden bg-zinc-900">
                      <img
                        src={project.image}
                        alt={project.title}
                        loading="lazy"
                        className="h-full w-full object-cover opacity-80 transition-all duration-500 group-hover:scale-[1.04] group-hover:opacity-100"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/80 via-transparent to-transparent" />
                    </div>
                    <div className="flex flex-1 flex-col p-6">
                      <div className="mb-2 flex items-start justify-between gap-4">
                        <h3 className="text-lg font-semibold tracking-tight">{project.title}</h3>
                        <ArrowUpRight className="h-4 w-4 shrink-0 text-zinc-600 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-white" />
                      </div>
                      <p className="mb-5 text-sm leading-relaxed text-zinc-400">{project.description}</p>
                      <div className="mt-auto flex flex-wrap gap-1.5">
                        {project.tech.map((tech) => (
                          <span
                            key={tech}
                            className="rounded-md border border-white/[0.06] bg-white/[0.03] px-2 py-1 font-mono text-[11px] text-zinc-400"
                          >
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="scroll-mt-24 px-6 py-24">
          <div className="mx-auto max-w-6xl">
            <div className="relative overflow-hidden rounded-3xl border border-white/[0.08] bg-gradient-to-b from-zinc-900/70 to-zinc-950 px-8 py-16 md:px-16 md:py-24">
              <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-white/[0.05] blur-3xl" />
              <div className="relative max-w-2xl">
                <SectionLabel index="02">Let's work together</SectionLabel>
                <p className="mb-10 -mt-4 text-lg leading-relaxed text-zinc-400">
                  I'm currently available for freelance projects. If you have an idea or need help with an
                  existing project, feel free to reach out.
                </p>
                <div className="flex flex-wrap gap-3">
                  <a
                    href="mailto:parkerdevwork@gmail.com"
                    className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-medium text-black transition-all hover:bg-zinc-200 hover:shadow-[0_0_40px_-8px_rgba(255,255,255,0.5)]"
                  >
                    <Mail className="h-4 w-4" />
                    parkerdevwork@gmail.com
                  </a>
                  <a
                    href="https://github.com/parkerstafford"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 rounded-full border border-white/[0.12] px-6 py-3 text-sm text-zinc-200 transition-colors hover:border-white/[0.3] hover:bg-white/[0.04]"
                  >
                    <Github className="h-4 w-4" />
                    GitHub
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-white/[0.06] px-6 py-8">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 text-xs text-zinc-600 md:flex-row">
          <p>© {new Date().getFullYear()} Parker Stafford</p>
          <p className="font-mono">Built with React &amp; Tailwind CSS</p>
        </div>
      </footer>
    </div>
  );
}
